export const LOADING = 'LOADING';

export function setLoading(isLoading) {
    return {
        type: LOADING,
        payload: isLoading 
    }
}